document.getElementById('surflyButton').addEventListener('click', surflyButton);

function surflyButton () {
  Surfly.session().startLeader();
}
